import { createTheme } from '@material-ui/core/styles';

const materialTheme = createTheme({
  typography: {
    htmlFontSize: 10,
    fontFamily: 'inherit',
  },
});

export default materialTheme;
